import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "assignKidCheckBox", "createKidCheckBox",
    "assignForm", "newForm",
    "kidSelection",
  ]

  connect() {
    this.toggleSelect()
  }

  toggleSelect() {
    const value = this.kidSelectionTarget.value

    if (value === "assign_existing_kids") {
      this.assignKidCheckBoxTarget.checked = true
      this.createKidCheckBoxTarget.checked = false
      this.assignFormTarget.classList.remove("hidden")
      this.newFormTarget.classList.add("hidden")
    } else if (value === "create_new_kid") {
      this.createKidCheckBoxTarget.checked = true
      this.assignKidCheckBoxTarget.checked = false
      this.assignFormTarget.classList.add("hidden")
      this.newFormTarget.classList.remove("hidden")
    } else {
      this.assignKidCheckBoxTarget.checked = false
      this.createKidCheckBoxTarget.checked = false
      this.assignFormTarget.classList.add("hidden")
      this.newFormTarget.classList.add("hidden")
    }
  }
}
